import { useEffect, useState } from "react";
import cn from "classnames";
import Icon from "../../Icon";
import Modal from "../../Modal";
import styles from "../File.module.sass";
import common from "../../../i11/Common";

import Checkbox from "../../Checkbox";
import CropperComponent from "../cropper";

import { UseApi } from "../../../hooks/use-api";
import { useUser } from "../../../context";
import { UploadImage } from "../../../Services/lib/admin";
import { UseDisclosure } from "../../../hooks/use-disclosure";

const ImagesUpload = ({
	where,
	isDisabled,
	label,
	initialImage,
	initialIMGList,
	aspect_ratio,
	callBack = () => {},
}) => {
	const { locale } = useUser();

	const [selectedFilters, setSelectedFilters] = useState([]);
	const [index, setIndex] = useState(null);
	const selectHandleChange = (id) => {
		if (selectedFilters.includes(id)) {
			setSelectedFilters(selectedFilters.filter((x) => x !== id));
		} else {
			setSelectedFilters((selectedFilters) => [...selectedFilters, id]);
		}
	};
	const { isOpen, onClose, onOpen } = UseDisclosure();
	const [image, setImage] = useState();
	const [{ isLoading }, upload] = UseApi({
		service: UploadImage,
		config: {
			headers: {
				"Content-Type": "Multipart/form-data",
			},
			params: {
				miniSize: "NO",
				whereFolder: where || "TEMPLATES",
			},
		},
	});
	const [cropFile, setCropFile] = useState();
	const [imageUrls, setImageUrls] = useState([]);
	const [imgHttpsUrls, setImgHttpsUrls] = useState({
		core_image_url: "",
		image_list: [],
	});

	const onChange = (e) => {
		if (!e.target.files) return;
		if (e.target?.files[0]?.type === "image/gif") {
			setImage(e.target.files);
		} else {
			const url = URL.createObjectURL(e.target.files[0]);
			setCropFile(url);
			onOpen();
		}
	};
	const onClose_ = () => {
		onClose();
		setCropFile();
	};

	const uploadIMG = async (image_) => {
		const formData = new FormData();
		formData.append("image", image_[0]);
		const res = await upload(formData);
		if (res) {
			if (index !== null) {
				const chngItem = { ...imgHttpsUrls };
				if (index === 0) {
					chngItem.core_image_url = res.core_image_url;
				} else {
					chngItem.image_list[index - 1] = {
						url: res.core_image_url,
					};
				}
				setImgHttpsUrls(chngItem);
				callBack(chngItem);
				const imgURlsArr = [...imageUrls];
				imgURlsArr[index] = {
					localUrl: URL.createObjectURL(image_[0]),
					url: res.core_image_url,
				};

				setImageUrls(imgURlsArr);
				setSelectedFilters([]);
				setIndex(null);
				return;
			}

			const first = imageUrls.length === 0;
			const obj = {
				core_image_url: first
					? res.core_image_url
					: imgHttpsUrls.core_image_url || res.core_image_url,
				image_list: first
					? []
					: [...imgHttpsUrls.image_list, { url: res.core_image_url }],
			};

			setImgHttpsUrls(obj);
			callBack(obj);
			setImageUrls((p) => [
				...p,
				{
					localUrl: URL.createObjectURL(image_[0]),
					url: res.core_image_url,
				},
			]);
		}
	};
	useEffect(() => {
		if (!image) return;
		uploadIMG(image);
	}, [image]);
	useEffect(() => {
		const list = [
			...initialIMGList.map((e) => {
				return {
					localUrl: e?.url || "",
					url: e?.url || "",
				};
			}),
		];
		const imgObj = {
			core_image_url: "",
			image_list: list.map((e) => {
				return { url: e.url };
			}),
		};
		if (initialImage) {
			imgObj.core_image_url = initialImage;
			list.unshift({
				localUrl: initialImage,
				url: initialImage,
			});
		}

		setImageUrls(list);
		setImgHttpsUrls(imgObj);
	}, []);

	const deleteFile = (file_) => {
		let filter = imageUrls.filter(
			(item) => !selectedFilters.includes(item.url)
		);
		if (file_) {
			filter = imageUrls.filter((item) => file_ !== item.url);
		}

		setImageUrls(filter);
		setSelectedFilters([]);
		const webUrls = filter.map((p) => p.url);
		const ls = webUrls.length >= 2 ? [...webUrls].slice(1) : [];
		const imageList = ls.map((e) => {
			return {
				url: e,
			};
		});

		const obj =
			filter.length === 0
				? {
						core_image_url: "",
						image_list: [],
				  }
				: {
						core_image_url: filter[0].url,
						image_list: imageList,
				  };
		setImgHttpsUrls(obj);
		callBack(obj);
	};

	return (
		<>
			{label && <div className={styles.label}>{label}</div>}

			{selectedFilters.length >= 1 && (
				<div className={styles.deleteItem}>
					<div>
						<Icon reicon="checkboxMinus" />
						{`${selectedFilters.length} file selected`}
					</div>
					<button
						type="button"
						onClick={() => deleteFile()}
						disabled={isDisabled}
					>
						{common[locale].delete_file}
					</button>
				</div>
			)}
			<div className={styles.containerBox}>
				{imageUrls.length >= 1 && (
					<div
						className={cn(
							styles.imgContainer,
							selectedFilters.includes(imageUrls[0].url) &&
								styles.selected
						)}
						style={{
							marginRight: "12px",
						}}
					>
						<img
							className={cn(styles.imgStyle, styles.mainImgStyle)}
							src={imageUrls[0].localUrl}
							alt="image_0"
							loading="lazy_0"
						/>
						<Checkbox
							className={styles.hoverCheck}
							value={selectedFilters.includes(imageUrls[0].url)}
							onChange={() =>
								selectHandleChange(imageUrls[0].url)
							}
						/>
						<button className={styles.hoverChange} type="button">
							{common[locale].change_image}
							<input
								type="file"
								disabled={isLoading || isDisabled}
								accept="image/png, image/jpeg, image/gif"
								className={styles.input}
								onChange={(val) => {
									setIndex(0);
									onChange(val);
								}}
							/>
						</button>

						<button
							type="button"
							className={styles.hoverDelete}
							onClick={() => deleteFile(imageUrls[0].url)}
							disabled={isDisabled}
						>
							<Icon name="trash" fill="#FF6A55" />
						</button>
					</div>
				)}

				<div class={imageUrls.length !== 0 && styles.wrapContainer}>
					{imageUrls.length >= 2 &&
						[...imageUrls].slice(1).map((e, i) => {
							return (
								<div
									className={cn(
										styles.imgContainer,
										selectedFilters.includes(
											imageUrls[i + 1].url
										) && styles.selected
									)}
									key={i}
									style={{
										height:
											imageUrls.length === 2
												? "48%"
												: "100%",
									}}
								>
									<img
										className={styles.imgStyle}
										src={e.localUrl}
										alt={`image_${i}`}
										loading="lazy"
									/>
									<Checkbox
										className={styles.hoverCheck}
										onChange={() =>
											selectHandleChange(
												imageUrls[i + 1].url
											)
										}
										value={selectedFilters.includes(
											imageUrls[i + 1].url
										)}
									/>
									<button
										className={styles.hoverChange}
										type="button"
									>
										{common[locale].change}
										<input
											type="file"
											disabled={isLoading || isDisabled}
											accept="image/png, image/jpeg, image/gif"
											className={styles.input}
											onChange={(val) => {
												setIndex(i + 1);
												onChange(val);
											}}
										/>
									</button>

									<button
										type="button"
										className={styles.hoverDelete}
										disabled={isDisabled}
										onClick={() =>
											deleteFile(imageUrls[i + 1].url)
										}
									>
										<Icon name="trash" fill="#FF6A55" />
									</button>
								</div>
							);
						})}
					{imageUrls.length !== 5 && (
						<div className={cn(styles.imgStyle, styles.addFile)}>
							<input
								disabled={
									isLoading ||
									isDisabled ||
									imageUrls.length >= 5
								}
								accept="image/png, image/jpeg, image/gif"
								className={styles.input}
								type="file"
								onChange={onChange}
							/>
							<div className={styles.btn}>
								{isLoading ? (
									<span className={styles.loader}></span>
								) : (
									<Icon name="upload" size="24" />
								)}
								<p>
									{isLoading
										? common[locale].upload
										: common[locale].file_or_drag}
								</p>
							</div>
						</div>
					)}
				</div>
			</div>
			<Modal
				outerClassName={styles.cropOuter}
				visible={isOpen}
				onClose={onClose_}
			>
				{cropFile && (
					<CropperComponent
						aspect_ratio={aspect_ratio || 1}
						setImage={setImage}
						onClose={onClose_}
						image={cropFile}
					/>
				)}
			</Modal>
		</>
	);
};

export default ImagesUpload;
